import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitobanglore() {



  const cardData =
  {
    keyword: 'Mumbai to Bangalore Cab ',
    heading: 'Shambhu Cabs: Mumbai to Bangalore Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Bangalore Cab services, providing safe, comfortable, and hassle-free travel for families, corporate travelers, business groups, and long-distance commuters heading to Bangalore. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and relaxing journey from Mumbai to Bangalore with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes long-distance travel convenient, stress-free, and enjoyable. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Bangalore cab services for travelers seeking comfort, safety, punctuality, and a reliable intercity travel experience.',

    top: 'Top Places to Visit in Bangalore with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace, built in 1878 by Chamaraja Wadiyar, is one of the most iconic landmarks of the city. Inspired by England’s Windsor Castle, the palace features fortified towers, turrets, and elegant woodcarvings with intricate floral motifs. Inside, visitors can admire grand halls, antique furniture, stunning paintings, and photographs reflecting the royal Wadiyar family’s legacy. The sprawling palace grounds host cultural events, music concerts, and exhibitions, making it a center for both history and contemporary art. Its regal architecture amidst lush gardens is a must-see for anyone visiting Bangalore."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden, spread across 240 acres, is one of India’s most famous botanical gardens, dating back to 1760. Known for its glasshouse inspired by London’s Crystal Palace, Lalbagh hosts biannual flower shows attracting thousands of visitors. The garden contains centuries-old trees, exotic plant species, a lake, and well-maintained walking paths. Birdwatchers and nature enthusiasts enjoy the serene environment, while families and joggers use the open spaces for recreation. Lalbagh is both a natural haven and a living museum of flora."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a sprawling 300-acre green oasis in the heart of Bangalore city, established in 1870. With its dense tree cover, well-laid paths, statues, and colonial-era architecture, it serves as the city’s lungs and a hub for walkers, cyclists, and families. The park also hosts the State Central Library, Bandstand, and the Government Museum. Seasonal flower beds, fountains, and playgrounds make Cubbon Park ideal for leisure, photography, and connecting with nature while exploring Bangalore’s colonial history."
  },
  {
    "title": "Tipu Sultan’s Summer Palace",
    "description": "Tipu Sultan’s Summer Palace, located near the city center, is an exquisite example of Indo-Islamic architecture from the 18th century. Built primarily of teakwood, the palace features intricately carved arches, balconies, and pillars. The walls are adorned with frescoes depicting historical events from Tipu Sultan’s reign. The palace gives visitors a glimpse into the life, administration, and artistic tastes of the Mysorean ruler. Its peaceful gardens and nearby Krishna Raja Sagara connections enhance the historical atmosphere, making it a cultural hotspot in Bangalore."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is the seat of the Karnataka Legislative Assembly and a prime example of Neo-Dravidian architecture. Completed in 1956, the imposing granite structure features grand domes, ornate pillars, and intricate carvings symbolizing Karnataka’s heritage. While interior entry is restricted, the exterior itself is a marvel, especially when illuminated at night. Surrounded by lush lawns and statues, Vidhana Soudha is a must-see landmark reflecting Bangalore’s political and architectural significance."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "ISKCON Temple, also known as Sri Radha Krishna Temple, is one of the largest ISKCON temples in the world. Located on Hare Krishna Hill, it features modern architectural design combined with traditional spiritual elements. The temple is renowned for its stunning deities, elaborate carvings, and peaceful ambiance. Visitors can attend daily aartis, participate in cultural programs, and enjoy vegetarian prasadam. The temple complex includes a Vedic heritage museum, gardens, and lecture halls, making it both a spiritual and educational attraction in Bangalore."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park, located about 22 km from Bangalore, is a major wildlife sanctuary housing tigers, lions, elephants, and a variety of herbivores and birds. The park offers a safari experience, butterfly park, and zoo for visitors. The natural setting amidst hills and forests makes it ideal for wildlife photography, educational trips, and eco-tourism. Families and nature lovers enjoy guided tours and interactive sessions about conservation efforts, making Bannerghatta a perfect day trip from the city."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s bustling shopping hub, known for vibrant markets, boutique stores, and traditional handicrafts. Visitors can shop for clothing, jewelry, footwear, accessories, and souvenirs at competitive prices. The street is also lined with restaurants, cafes, and street food vendors offering local delicacies like dosas, idlis, and chaats. Its lively atmosphere, colorful displays, and mix of modern and traditional goods make Commercial Street a must-visit for shoppers and tourists seeking an authentic city experience."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake, situated in central Bangalore, is one of the city’s largest and oldest lakes. It is famous for boating, walking paths, and scenic views surrounded by tree-lined avenues. The lake also has several small islands, some hosting ancient temples, enhancing the spiritual and aesthetic experience. Morning walkers, photographers, and nature enthusiasts frequently visit Ulsoor Lake to enjoy its calm water, migratory birds, and peaceful environment amidst Bangalore’s urban hustle."
  },
  {
    "title": "Nandi Hills",
    "description": "Nandi Hills, located about 60 km from Bangalore, is a popular hill station and sunrise viewpoint. With an altitude of 1,478 meters, it offers panoramic views of the surrounding plains, mist-covered valleys, and historic structures like Tipu Sultan’s Fort. Trekking, cycling, and paragliding are favorite activities here. The cool climate, lush greenery, and ancient temples like Nandi Temple make it a rejuvenating escape from the city. Nandi Hills is also historically significant, serving as Tipu Sultan’s summer retreat and military outpost."
  }
],




"services": [
  {
    "name": "Mumbai Bangalore Taxi",
    "description": "Mumbai Bangalore Taxi offers long-distance, reliable, and comfortable intercity travel between Mumbai and Bangalore. With expert chauffeurs, well-maintained vehicles, and smooth route planning, this service is ideal for business tours, student travel, family trips, and long-route journeys. Covering over 980 km, the cab service ensures a relaxed highway experience with multiple stop options, safe driving, and on-time pickup from any location in Mumbai."
  },
  {
    "name": "One-Way Cab Mumbai Bangalore",
    "description": "One-Way Cab Mumbai Bangalore is perfect for travelers needing a drop-off in Bangalore without a return trip. This economical and convenient option serves individuals relocating, professionals joining offices, students shifting hostels, and families traveling one-way. The service ensures transparent pricing, flexible timings, verified drivers, and a comfortable long-distance ride across the Mumbai–Bangalore corridor."
  },
  {
    "name": "Affordable Cab Mumbai Bangalore",
    "description": "Affordable Cab Mumbai Bangalore provides a budget-friendly option for long-distance intercity travel. Equipped with fuel-efficient cars and reliable chauffeurs, this service is ideal for travelers seeking economical yet comfortable transport. Transparent fare structures, clean vehicles, and safe highway driving make it a perfect choice for customers looking for value-packed travel."
  },
  {
    "name": "Best Taxi Mumbai Bangalore",
    "description": "Best Taxi Mumbai Bangalore delivers premium-quality service with punctual pickups, trained chauffeurs, and superior comfort. It is preferred for long journeys, business tours, family travel, and corporate transfers. The service focuses on smooth highway driving, safety, and a seamless intercity travel experience covering major stops like Pune, Satara, Kolhapur, and Belgaum."
  },
  {
    "name": "SUV Cab Mumbai Bangalore",
    "description": "SUV Cab Mumbai Bangalore offers spacious, powerful, and comfortable SUVs ideal for long-distance journeys with luggage or multiple passengers. Featuring ample legroom, smooth suspension, and strong highway performance, SUVs ensure a premium and relaxed travel experience for families, groups, and corporate travelers heading to Bangalore."
  },
  {
    "name": "Sedan Cab Mumbai Bangalore",
    "description": "Sedan Cab Mumbai Bangalore provides well-maintained, comfortable, and economical sedans for a smooth intercity ride. With excellent mileage, soft seating, and a quiet cabin, sedans are perfect for small families, solo travelers, and business passengers seeking an affordable yet comfortable long-route travel option between Mumbai and Bangalore."
  },
  {
    "name": "Long Distance Cab Mumbai Bangalore",
    "description": "Long Distance Cab Mumbai Bangalore is designed for extended road journeys, offering comfort-oriented vehicles, skilled long-route drivers, and flexible travel schedules. This service ensures safe overtakes, proper rest stops, smooth route navigation, and stress-free travel, making it suitable for multi-hour intercity journeys across major highways."
  },
  {
    "name": "24×7 Cab Mumbai Bangalore",
    "description": "24×7 Cab Mumbai Bangalore ensures round-the-clock availability for urgent travel, late-night departures, corporate emergencies, and early-morning pickups. The service provides safe highway driving at all hours, fast booking confirmation, and dependable chauffeurs ensuring a secure and convenient long-distance journey regardless of timing."
  },
  {
    "name": "Corporate Cab Mumbai Bangalore",
    "description": "Corporate Cab Mumbai Bangalore provides professional chauffeur-driven vehicles for business travelers commuting between the two major metro cities. Ideal for executives, visiting delegates, and corporate teams, this service offers premium cars, punctuality, privacy, and smooth transfers suitable for meetings, conferences, and office relocations."
  },
  {
    "name": "Outstation Cab Mumbai Bangalore",
    "description": "Outstation Cab Mumbai Bangalore is ideal for long-distance travel, offering one-way, round-trip, and multi-day options for both personal and business use. With verified drivers, safe vehicles, flexible travel plans, and seamless booking, this service provides a reliable solution for extended trips across Maharashtra and Karnataka."
  },
  {
    "name": "Premium Cab Mumbai Bangalore",
    "description": "Premium Cab Mumbai Bangalore offers luxury sedans and high-end SUVs for passengers seeking superior comfort, style, and a VIP travel experience. With plush seating, clean cabins, and professional chauffeurs, this service is ideal for executives, NRI travelers, family tours, and customers wanting top-class travel throughout the long journey."
  },
  {
    "name": "Safe Taxi Mumbai Bangalore",
    "description": "Safe Taxi Mumbai Bangalore prioritizes safety through GPS-enabled tracking, sanitized vehicles, background-verified chauffeurs, and highway driving expertise. Ideal for women travelers, senior citizens, business professionals, and family groups, this service ensures a secure and stress-free journey over the extensive Mumbai–Bangalore route."
  },
  {
    "name": "Mumbai Bangalore Pickup Drop",
    "description": "Mumbai Bangalore Pickup Drop provides simple, point-to-point intercity transfer between any address in Mumbai and any location in Bangalore. It is ideal for hotel guests, business travelers, families, and students. With door-to-door convenience, punctual drivers, and a smooth travel experience, this service ensures hassle-free transfers."
  },
  {
    "name": "Family Cab Mumbai Bangalore",
    "description": "Family Cab Mumbai Bangalore offers spacious seating, comfortable interiors, child-friendly arrangements, and safe driving for long-distance family travel. Ideal for vacations, family relocations, events, and extended stays, the service ensures a relaxed and enjoyable road journey suited for all age groups."
  },
  {
    "name": "Highway Cab Mumbai Bangalore",
    "description": "Highway Cab Mumbai Bangalore specializes in long/highway routes with experienced drivers who know the best stops, traffic-free stretches, and smooth patches of the Mumbai–Pune Expressway and NH48. It ensures minimal travel time, safe overtakes, and a stable long-distance driving experience."
  },
  {
    "name": "Fast Cab Mumbai Bangalore",
    "description": "Fast Cab Mumbai Bangalore offers quick pickups, rapid booking confirmation, and fast yet safe highway travel. Designed for urgent business needs, medical travel, or last-minute trip plans, this service ensures that customers reach Bangalore on time through optimized route selection and expert long-distance drivers."
  },
  {
    "name": "Mumbai to Electronic City Cab",
    "description": "Mumbai to Electronic City Cab provides direct and convenient long-distance travel to Bangalore’s major IT hub—Electronic City. Ideal for software professionals, corporate travelers, and families visiting the tech district, this service offers comfortable cars, skilled chauffeurs, and door-to-door pickup/drop at any apartment, office, or hotel in Electronic City."
  }
],

"tableData": [
  ["Mumbai Bangalore Taxi", "One-Way Cab Mumbai Bangalore"],
  ["Affordable Cab Mumbai Bangalore", "Best Taxi Mumbai Bangalore"],
  ["SUV Cab Mumbai Bangalore", "Sedan Cab Mumbai Bangalore"],
  ["Long Distance Cab Mumbai Bangalore", "24×7 Cab Mumbai Bangalore"],
  ["Corporate Cab Mumbai Bangalore", "Outstation Cab Mumbai Bangalore"],
  ["Premium Cab Mumbai Bangalore", "Safe Taxi Mumbai Bangalore"],
  ["Mumbai Bangalore Pickup Drop", "Family Cab Mumbai Bangalore"],
  ["Highway Cab Mumbai Bangalore", "Fast Cab Mumbai Bangalore"],
  ["Mumbai to Electronic City Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Bangalore Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Bangalore cab services, ideal for long-distance travel, business trips, and comfortable intercity journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Enjoy a smooth and relaxing ride in spacious, air-conditioned, and well-maintained cabs for your Mumbai to Bangalore trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long Highway Routes",
    "WhyChoosedescription": "Our professional drivers are experienced in long-route travel and familiar with the Mumbai to Bangalore highway, ensuring safe and timely journeys."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear and upfront pricing—fuel, tolls, and driver allowances included—so your Mumbai to Bangalore cab trip stays hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available 24/7 to assist with bookings, route planning, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Long-Distance Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized multi-day packages designed to meet your Mumbai to Bangalore travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly sanitized and cleaned before every trip, ensuring a hygienic and safe journey."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We provide punctual pickups and reliable service, making your long-distance Mumbai to Bangalore journey smooth and comfortable."
  }
]




























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Bangalore cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Bangalore cab services with highly experienced long-distance drivers.',
  },
  {
    question: 'How can I book a Mumbai to Bangalore cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for seamless booking assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Bangalore cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, spacious SUVs, and luxury cars designed for long-distance interstate travel.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Bangalore route?',
    answer: 'Yes, our drivers are licensed, professional, and trained for long highway routes including Mumbai to Bangalore, ensuring a safe and smooth journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Bangalore cab?',
    answer: 'Absolutely. You can choose any pickup point in Mumbai and select your preferred drop-off location anywhere in Bangalore.',
  },
  {
    question: 'Is the Mumbai to Bangalore cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock cab booking services for Mumbai to Bangalore to suit your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Bangalore cab bookings?',
    answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety and hygiene protocols throughout long-distance trips.',
  },
  {
    question: 'What payment options are available for Mumbai to Bangalore cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
  },
  {
    question: 'Is customer support available during the Mumbai to Bangalore journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Bangalore travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Nair',
    feedback: 'Our Mumbai to Bangalore trip with Shambhu Cabs was extremely comfortable. The driver was skilled and the car was spotless.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Menon',
    feedback: 'Fantastic service! Shambhu Cabs made our long-distance journey from Mumbai to Bangalore smooth and stress-free.',
    rating: 5,
  },
];















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bangalore Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-bangalore-cab.jpg",
  "description": "Shambhu Cabs offers safe, comfortable, and reliable Mumbai to Bangalore cab services for one-way and long-distance trips. Book sedans, SUVs, or premium cars for family travel, corporate trips, and highway journeys. Enjoy 24×7 service, fast travel, affordable fares, and convenient pickup-drop, including Mumbai to Electronic City.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "11500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-bangalore-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Bangalore Cab | Outstation & Corporate Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Bangalore cab with Shambhu Cabs. Safe, affordable, and comfortable taxi service for one-way and long-distance trips, family travel, corporate travel, and highway journeys. Available 24×7 with sedans, SUVs, and premium cars, including pickup-drop to Electronic City."
  />

  <meta
    name="keywords"
    content="Mumbai Bangalore Taxi, One-Way Cab Mumbai Bangalore, Affordable Cab Mumbai Bangalore, Best Taxi Mumbai Bangalore, SUV Cab Mumbai Bangalore, Sedan Cab Mumbai Bangalore, Long Distance Cab Mumbai Bangalore, 24×7 Cab Mumbai Bangalore, Corporate Cab Mumbai Bangalore, Outstation Cab Mumbai Bangalore, Premium Cab Mumbai Bangalore, Safe Taxi Mumbai Bangalore, Mumbai Bangalore Pickup Drop, Family Cab Mumbai Bangalore, Highway Cab Mumbai Bangalore, Fast Cab Mumbai Bangalore, Mumbai to Electronic City Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/24.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitobanglore;